var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoColorSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 39,
    rx: 19,
    fill: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.2308C12 17.905 12 17.5792 12 17.2501C12.0098 17.2169 12.0262 17.187 12.0262 17.1537C12.0688 16.5487 12.2031 15.9635 12.416 15.3984C13.6084 12.2036 16.881 10.4217 20.1699 11.1697C23.0166 11.8179 25.1819 14.4077 25.3261 17.3532C25.3916 18.6597 25.123 19.8931 24.4809 21.0367C24.363 21.2461 24.2352 21.4489 24.1009 21.675C24.1435 21.7116 24.1893 21.7415 24.2287 21.778C24.9788 22.536 25.7257 23.2973 26.4759 24.052C26.6986 24.2747 26.9148 24.5008 27 24.8166C27 24.9463 27 25.0726 27 25.2022C26.9803 25.2455 26.9574 25.2887 26.9443 25.3319C26.8624 25.558 26.7216 25.7375 26.5152 25.8538C26.0893 26.0999 25.6438 26.0234 25.2671 25.6411C24.4612 24.8266 23.6587 24.0121 22.8561 23.1976C22.82 23.161 22.8037 23.1045 22.7873 23.0746C22.4892 23.2707 22.2468 23.4436 21.988 23.5932C20.6252 24.3911 19.1577 24.667 17.6082 24.4177C16.0981 24.175 14.8205 23.4702 13.7788 22.3366C12.9041 21.3824 12.3472 20.2654 12.1147 18.9855C12.0688 18.7362 12.036 18.4835 12 18.2308ZM23.7569 17.7421C23.7471 14.8931 21.477 12.5892 18.6565 12.5959C15.7803 12.6058 13.5626 14.9762 13.5789 17.7787C13.5953 20.5979 15.8327 22.9183 18.6761 22.9117C21.5949 22.905 23.77 20.4782 23.7569 17.7421Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4047 13.3906C19.9902 13.4937 21.1728 14.2384 21.9099 15.6745C22.1163 16.0768 21.9656 16.5356 21.5856 16.745C21.2056 16.9545 20.747 16.8215 20.5275 16.4225C20.308 16.0203 20.0394 15.6612 19.6561 15.4053C19.2925 15.1626 18.8928 15.0196 18.4539 14.993C18.2508 14.9797 18.0444 14.9731 17.8642 14.86C17.5727 14.6772 17.4285 14.3115 17.5203 13.9724C17.6087 13.6366 17.9035 13.4039 18.2475 13.3906C18.2999 13.3906 18.3523 13.3906 18.4047 13.3906Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 28.3273,
    y1: -5,
    x2: -7.28004,
    y2: 34.9773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62CEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D8CBB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoColorSearch);
export default __webpack_public_path__ + "static/media/ico-color-search.94b97414087ba397584d48e3149a6aa2.svg";
export { ForwardRef as ReactComponent };